import React from 'react';
import classNames from 'classnames';

export function PageWrapper({ className, children }) {
    return (
        <div className={classNames('h-full pt-[64px] pb-[85px] overflow-auto lg:pt-0 lg:pb-0 lg:pl-[300px]', className)}>
            {children}
        </div>
    );
}
